// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var StarRatingScale$ReactHooksTemplate = require("./StarRatingScale.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");

function StarRatingDefaultForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var language = props.language;
  var mandatory = props.mandatory;
  var starRating = props.starRating;
  var rawText = StarRating$ReactHooksTemplate.getTextTranslation(starRating, SurveyLanguage$ReactHooksTemplate.name(language));
  var rawDescription = StarRating$ReactHooksTemplate.getDescriptionTranslation(starRating, SurveyLanguage$ReactHooksTemplate.name(language));
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawText, substitutionVariables) + (
    mandatory ? " *" : ""
  );
  var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawDescription, substitutionVariables);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: titleHtml
                              }
                            }),
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            })
                      ]
                    }),
                JsxRuntime.jsx(StarRatingScale$ReactHooksTemplate.make, {
                      starRating: starRating,
                      onChange: props.onChange,
                      layout: "Survey"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = StarRatingDefaultForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
